export default __webpack_public_path__ + "d4c6ece66f0cde9580112bd8ceec9b91.png";